// extracted by mini-css-extract-plugin
module.exports = {"balanceRow":"Summary_balanceRow__23WZ5","staticText":"Summary_staticText__3d-er"};